import React from "react";
import cookie from "react-cookies";
import { Typography, Tag, Spin, Progress, Popconfirm, Icon, Button, Menu, Dropdown, Tooltip } from 'antd';
import { startTiling } from '../../action/slides.action'
import { updateTags } from '../../action/search.action';
import { updateSlide } from '../../action/slide.update.action';
import { Link } from 'react-router-dom';

const {Text} = Typography;

const iconFontSize = "15px";
const tagColors = ['magenta', 'volcano', 'blue', 'green', 'purple']

export const getPreviewComponent = (slide, is_cloud, isMobile) => {
    let previewPath = slide.preview_image;
    let scandriveId = slide.scandrive_id;

    if (is_cloud === false) {
        previewPath = previewPath.replace("/static/", "");
        if (slide.status === 12) {
            previewPath = "/scan-hdd/" + scandriveId + previewPath.replace('stitched_small_viewer', 'selection_marked');
        }
        else {
            previewPath = "/scan-ssd/" + previewPath.replace('stitched_small_viewer', 'selection_marked');
        }
    }

    return <img
        width={isMobile ? 100: 200}
        alt="logo"
        src={previewPath}
    />
}

export const getLabelComponent = (slide, is_cloud, isMobile) => {
    let labelPath = slide.preview_image;
    let scandriveId = slide.scandrive_id;

    if (is_cloud === false) {
        labelPath = labelPath.replace("/static/", "");
        if (slide.status === 12) {
            labelPath = "/scan-hdd/" + scandriveId +labelPath.replace('stitched_small_viewer', 'barcode_crop');
        }
        else {
            labelPath = "/scan-ssd/" + labelPath.replace('stitched_small_viewer', 'barcode_crop');
        }
    }

    return <img
        height={96}
        alt="barcode-does-not-exist"
        src={labelPath}
    />
}

export const getNameComponent = (slide, handleNameChange) => {
    return  <Text
            onClick={(event) => event.stopPropagation()}
            editable={{ onChange: (newName) => handleNameChange(slide, newName)}}>                                            
        {slide.name}
    </Text>
}

export const getUploadComponent = (slide, allIds, handleUpload) => {

    var uploadStatus = slide.upload_status;

    var uploadComponent = null;

    if (slide.isFetching) {
        return getBusyComponent();
    }

    if (slide.status === 9 || slide.status === 12) {

        let adminMenu = <Menu>
                            <Menu.Item>
                                <Button onClick={(event) => {
                                        event.stopPropagation();
                                        handleUpload(slide.morphle_id, slide.id, allIds, false, false);
                                    }}>Upload without Debug</Button>
                            </Menu.Item>
                            <Menu.Item>
                                <Button onClick={(event) => {
                                        event.stopPropagation();
                                        handleUpload(slide.morphle_id, slide.id, allIds, true, false);
                                    }}>Upload with Debug</Button>
                            </Menu.Item>
                        </Menu>
        
        let adminUploadButton = <Dropdown key="admin-upload" overlay={adminMenu} placement="topLeft">
                                    <Icon key="cloud-upload" style={{ fontSize: "20px", textAlign: "center" }} type="upload" onClick={(event) => { event.stopPropagation() }}/>
                                </Dropdown>
        
        let uploadButton = <Tooltip title="Upload">
                        <Icon
                            onClick={(event) => {
                                event.stopPropagation();
                                handleUpload(slide.morphle_id, slide.id, allIds, false, false);
                            }} 
                            style={{ fontSize: "20px"}} type="upload" />
                    </Tooltip>

        if (uploadStatus === 0 && cookie.loadAll().deployment_mode === 'offline') {
            uploadComponent = cookie.loadAll().superuser === "true" ? adminUploadButton: uploadButton
        } else if (uploadStatus === 2) {
            uploadComponent = <Icon style={{ fontSize: "20px"}}  type="cloud-sync" />
        } else if (uploadStatus === 100) {
            uploadComponent = <div key="2">Error in Upload</div>
        } else if (uploadStatus === 1) {
            // var uploadTracker = [
            //     <Dropdown overlay={this.uploading_menu} placement="topRight" key ="0">
            //       <div style={{fontSize: "10"}}>
            //         <Progress
            //           type="circle"
            //           key={0}
            //           format={percent => String(parseFloat(percent.toFixed(2)) + '%')}
            //           percent={100}
            //           successPercent={this.state.upload_percent}
            //           showInfo={false}
            //           strokeColor="#f5667b" 
            //           width={20}
            //         />
            //       </div>
            //     </Dropdown>
            //   ];
            uploadComponent = <div key="2">
                Status : <Progress percent={slide.upload_percent} />
            </div>
        }
    } else {
        uploadComponent = <div>Scanning</div>
    }

    return uploadComponent;
}

export const getDbEntryComponent = (slide) => {
    var adminComponent = <a href={"/admin/api/slide/" + slide.id + "/change/"} key="3" onClick={(e) => e.stopPropagation()}>
        <span>Admin</span>
    </a>;

    return adminComponent;
}

export const getMorphleIDComponent = (slide) => {
    return <Link to={'#'} key="3" onClick={(e) => e.stopPropagation()}>
        <span>{slide.morphle_id}</span>
    </Link>;
}

var getBusyComponent = () => {
    let antIcon = <Icon type="loading" style={{ fontSize: iconFontSize }} spin />;
    return <Spin indicator={antIcon} />
}

export const getTagsComponent = (slide, dispatch, urlState) => {
    return <div>
        {slide.tags.map(tag => (
            <Tag
                key={tag}
                className="slidelist-tag"
                color={tagColors[0]}
                onClick={(event) => {
                    event.stopPropagation();
                    dispatch(updateTags([event.currentTarget.getAttribute('value')], urlState));
                }}
                value={tag}>
                {tag}
            </Tag>
        ))}
    </div>
}


export const getStarredComponent = (slide, handleStarButton) => {
    return slide.isFetching ? getBusyComponent() : <Icon
        onClick={(event) => {
            event.stopPropagation();
            handleStarButton(slide, !slide.starred);
        }}
        type="star"
        theme="filled"
        style={{ color: slide.starred === true ? "#f5667b" : "", fontSize: iconFontSize, padding: 20 }}
    />
}


export const getDeleteComponent = (slide, handleDelete) => {
    return slide.isFetching ? getBusyComponent() : <Popconfirm key={0}
        title="Are you sure delete this slide?"
        onConfirm={(event) => {
            event.stopPropagation();
            handleDelete(slide);
        }}
        okText="Yes"
        palcement="topRight"
        style={{ padding: 20 }}
        cancelText="No">
        <Icon
            onClick={(event) => event.stopPropagation()}
            type="delete"
            theme="filled"
            style={{ textAlign: 'center', fontSize: iconFontSize, padding: 20 }} />
    </Popconfirm>
}


export const getTilingComponent = (slide, allIds, dispatch) => {

    var tilingStatus = slide.tiling_status;

    var tilingComponent = null;

    if (slide.isFetching) {
        return getBusyComponent();
    }
    
    if (slide.status === 9 || slide.status === 12) {
        if (cookie.loadAll().superuser === "true") {
            if (tilingStatus === 0 && cookie.loadAll().deployment_mode === 'offline') {
                tilingComponent = <a
                    style={{ padding: 20 }}
                    onClick={(event) => {
                        event.stopPropagation();
                        dispatch(startTiling(slide.morphle_id, slide.id, allIds));
                    }}
                    key="2">
                    <div>Start Tiling</div>
                </a>
            } else if (tilingStatus === 2) {
                tilingComponent = <a href={"/v3/tissue/" + slide.morphle_id + "/tiling/"} key="2">
                    <div>Tiled</div>
                </a>
            } else if (tilingStatus === 100) {
                tilingComponent =
                    <div key="2">Error occured while Tiling. Check Jenkins 'raw_tiling'.</div>
            } else if (tilingStatus === 1) {
                tilingComponent = <div key="2">
                    Status : <Progress percent={slide.tiling_percent} />
                </div>
            }
        }

        if (slide.specimen_type === "blood" && tilingStatus === 2) {
            tilingComponent = <a href={"/v3/tissue/" + slide.morphle_id + "/tiling/"} key="2">
                <div>Tiled</div>
            </a>
        }
    }

    return tilingComponent;
}